import { render } from "./ModulePage.vue?vue&type=template&id=5f8d5079&scoped=true&ts=true"
import script from "./ModulePage.vue?vue&type=script&lang=ts"
export * from "./ModulePage.vue?vue&type=script&lang=ts"

import "./ModulePage.vue?vue&type=style&index=0&id=5f8d5079&scoped=true&lang=scss"
import "./ModulePage.vue?vue&type=style&index=1&id=5f8d5079&lang=scss"

import exportComponent from "/builds/Moodbuster2.0/server/web-server/repos/patient_portal_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8d5079"]])

export default __exports__